// js
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import OverlapAreaListItem from './OverlapAreaListItem';
// css
import '../../styles/components/analytics/OverlapAreaList.scss';


function OverlapAreaList({ areas, selectedArea, isAreaEnabled, onSelectArea }) {

  return (
    <div className='analytics__overlap-area-list'>
      <h6 className='analytics__overlap-title'>Percentage of Data Input</h6>
      <ul>
        {areas.map(a => {
          const selected = (a.id === selectedArea.id);
          const disabled = !isAreaEnabled(a);

          return (
            <li key={a.id} onClick={onSelectArea(a)} className={classNames({disabled})}>
              <OverlapAreaListItem area={a} selected={selected} />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

OverlapAreaList.propTypes = {
  areas: PropTypes.array.isRequired,
  selectedArea: PropTypes.object.isRequired,
  isAreaEnabled: PropTypes.func.isRequired,
  onSelectArea: PropTypes.func.isRequired
};

export default OverlapAreaList;




// WEBPACK FOOTER //
// ./src/components/analytics/OverlapAreaList.js